import gql from 'graphql-tag'
export default gql`query typeOfWorkQuery($id: Int!) {
  typeOfWork(id: $id) {
    code
    description
    maxChloride
    minPercentageFine
    id
  }
}`